// extracted by mini-css-extract-plugin
export default {"clickable":"TableItem_clickable__SVOM0","iconLabelContainer":"TableItem_iconLabelContainer__urrjv","label":"TableItem_label__eX-s4","iconPrimary":"TableItem_iconPrimary__mcmfQ"};